import React, { useState } from 'react';
import { useLocation,useNavigate } from 'react-router-dom';
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const MultiCityFlights = ({ flight, seg }) => {
  const [showDetails, setShowDetails] = useState(false);
  const [activeTab, setActiveTab] = useState('flight');
  const [showFareModal, setShowFareModal] = useState(false);
  const [selectedFareDetails, setSelectedFareDetails] = useState(null);
  const [showAllSegments, setShowAllSegments] = useState(false); // New state
   const [showDetailsv, setShowDetailsv] = useState(false);
    const [showFareModalv, setShowFareModalv] = useState(false);
    const [selectedFareDetailsv, setSelectedFareDetailsv] = useState(null);
  

  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const tripType = searchParams.get('tripType');

  // Compute lightweight meta (price, duration, departure, arrival) and prefer cached __meta
  const getFlightMeta = (f) => {
    if (!f) return { price: 0, duration: 0, departure: 0, arrival: 0 };
    if (f.__meta) return f.__meta;

    const price = (f?.Fare?.PublishedFare) || (f?.Fare?.BaseFare) || 0;

    const isNested = Array.isArray(f?.Segments) && f.Segments.some(Array.isArray);
    let firstSeg = null;
    let lastSeg = null;
    let duration = 0;

    if (isNested) {
      const firstLegArray = f.Segments[0] || [];
      const lastLegArray = f.Segments[f.Segments.length - 1] || [];
      firstSeg = firstLegArray[0] || null;
      lastSeg = lastLegArray[lastLegArray.length - 1] || null;
      const firstDur = Number(firstSeg?.Duration ?? firstSeg?.duration ?? 0) || 0;
      const lastAccum = Number(lastSeg?.AccumulatedDuration ?? lastSeg?.Duration ?? lastSeg?.duration ?? 0) || 0;
      const combined = firstDur + lastAccum;
      if (combined > 0) duration = combined;
      else if (lastAccum > 0) duration = lastAccum;
      else {
        const lastLegFlat = Array.isArray(lastLegArray) ? lastLegArray.flat() : [];
        duration = lastLegFlat.reduce((acc, s) => acc + (s.Duration || s.duration || 0), 0) || 0;
      }
    } else {
      const flat = (Array.isArray(f?.Segments) ? f.Segments.flat() : []) || [];
      firstSeg = flat[0] || null;
      lastSeg = flat[flat.length - 1] || null;
      duration = flat.reduce((acc, s) => acc + (s.Duration || s.duration || 0), 0) || 0;
      const lastAccum = Number(lastSeg?.AccumulatedDuration ?? 0) || 0;
      if (lastAccum > 0) duration = lastAccum;
    }

    const departure = firstSeg ? new Date(firstSeg?.Origin?.DepTime).getTime() : 0;
    const arrival = lastSeg ? new Date(lastSeg?.Destination?.ArrTime).getTime() : 0;

    const meta = { price, duration, departure, arrival, key: f.ResultIndex ?? JSON.stringify({ price, departure, arrival }) };
    try { f.__meta = meta; } catch (e) {}
    return meta;
  };

  const meta = getFlightMeta(flight);

  // Normalize segment groups: if Segments is nested (array of arrays) keep groups, otherwise wrap flat array
  const segmentGroups = Array.isArray(flight?.Segments)
    ? (flight.Segments.some(Array.isArray) ? flight.Segments : [flight.Segments])
    : [];

  // Flattened view (all legs) for totals/tables
  const segmentsFlat = Array.isArray(segmentGroups) && segmentGroups.flat ? segmentGroups.flat() : [];
  const firstSegment = segmentsFlat[0] || seg;
  const lastSegment = segmentsFlat[segmentsFlat.length - 1] || seg;

  // Calculate total duration
  const totalMinutes = Number(meta?.duration) || lastSegment?.AccumulatedDuration ||
    segmentsFlat.reduce((acc, s) => acc + (s.Duration || 0), 0);

  return (
    <div className='flights_card multicities'>
      {/* Airline */}
      <div className='flightsdet'>
        {segmentGroups.map((group, gIdx) => {
          const groupLegs = Array.isArray(group) ? group : (group ? [group] : []);
          if (!groupLegs || groupLegs.length === 0) return null;
          return (
            <div key={`group-${gIdx}`} className="multicity-group">
              {groupLegs.map((leg, idx) => (
                <div className='card' key={`g${gIdx}-l${idx}`}>
                  <div className='logo_side'>
                    <div>
                      <img
                        src={`/airlinesimages/${leg.Airline?.AirlineCode}.gif`}
                        alt={`${leg.Airline?.AirlineName} Logo`}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = '/airlinesimages/default.gif';
                        }}
                      />
                    </div>
                    <div className='carft_det'>
                      <p className='AirlineName'>{leg.Airline?.AirlineName}</p>
                      <p className='AirlineCode'>{leg.Airline?.AirlineCode} {leg.Airline?.FlightNumber}</p>
                      <p className='Craft'><b>Aircraft:</b> {leg.Craft}</p>
                    </div>
                  </div>
                  <div>
                    <p className='CityName'>{leg.Origin?.Airport?.CityName} ({leg.Origin?.Airport?.AirportCode})</p>
                    <p className='DepTime'>{new Date(leg.Origin?.DepTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })}</p>
                    <p className='Depdate'>{new Date(leg.Origin?.DepTime).toLocaleDateString('en-GB')}</p>
                    <p className='Terminal'>Terminal {leg.Origin?.Airport?.Terminal}</p>
                  </div>
                  <div>
                    <p className='Duration'>
                      {`${String(Math.floor(leg.Duration / 60)).padStart(2, '0')}h ${String(leg.Duration % 60).padStart(2, '0')}m`}
                    </p>
                    <p className='StopOver'>{leg.StopOver === false ? 'Non Stop' : 'Stop'}</p>
                  </div>
                  <div>
                    <p className='CityName'>{leg.Destination?.Airport?.CityName} ({leg.Destination?.Airport?.CityCode})</p>
                    <p className='DepTime'>{new Date(leg.Destination?.ArrTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })}</p>
                    <p className='Depdate'>{new Date(leg.Destination?.ArrTime).toLocaleDateString('en-GB')}</p>
                    <p className='Terminal'>Terminal {leg.Destination?.Airport?.Terminal}</p>
                  </div>
                </div>
              ))}
            </div>
          );
        })}
      </div>

      {/* Rest of your component (btndet, tabs, fare modal) remains the same */}
      <div className='btndet'>
        <div>
          <p className='fare'>₹ {meta.price ? Math.round(meta.price).toLocaleString('en-IN') : 'N/A'}</p>
          <p className='total'>Total Fare</p>
          <p className='Refundable'>{flight.IsRefundable ? 'Refundable' : 'Non-Refundable'}</p>
        </div>
        <div>
          <button
            type="button"
            className="btn"
            onClick={() => {
              setSelectedFareDetails(flight);
              setShowFareModal(true);
            }}
          >
            More fare
          </button>
        </div>
      </div>

     <div className='tab_flight_data'>
         <div className='view_details'>
          <button
            type="button"
            className='btn'
            onClick={() => {
              setShowDetailsv(!showDetailsv); 
              setSelectedFareDetailsv(flight);
            }}
          >
            View Details {showDetailsv ? <FaChevronUp className="ml-2" /> : <FaChevronDown className="ml-2" />}
          </button>
        </div>
      </div>

      {/* Tabs */}
      {showDetailsv && selectedFareDetailsv && (
           <div className="fare-modal-overlay" onClick={() => setShowDetailsv(false)}>
    <div className="fare-modal-content" onClick={(e) => e.stopPropagation()}>
      <button className="modal-close" onClick={() => setShowDetailsv(false)}>×</button>
        <div className='flight_tabs_section'>
          <div className='tab_headers'>
            <button onClick={() => setActiveTab('flight')} className={activeTab === 'flight' ? 'active' : ''}>
              Flight Details
            </button>
            <button onClick={() => setActiveTab('baggage')} className={activeTab === 'baggage' ? 'active' : ''}>
              Baggage
            </button>
            <button onClick={() => setActiveTab('cancellation')} className={activeTab === 'cancellation' ? 'active' : ''}>
              Cancellation
            </button>
            <button onClick={() => setActiveTab('fare')} className={activeTab === 'fare' ? 'active' : ''}>
              Fare Summary
            </button>
          </div>

          <div className='tab_content'>
            {/* Flight Details tab */}
           {activeTab === 'flight' && (
  <div className='flightsdet'>
    {segmentsFlat
      .slice(0, showAllSegments ? segmentsFlat.length : 6)
      .map((leg, idx) => (
        <React.Fragment key={idx}>
          {/* Flight Card */}
          <div className='card'>
            <div className='logo_side'>
              <div>
                <img
                  src={`/airlinesimages/${leg.Airline?.AirlineCode}.gif`}
                  alt={`${leg.Airline?.AirlineName} Logo`}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = '/airlinesimages/default.gif';
                  }}
                />
              </div>
              <div className='carft_det'>
                <p className='AirlineName'>{leg.Airline?.AirlineName}</p>
                <p className='AirlineCode'>{leg.Airline?.AirlineCode} {leg.FlightNumber}</p>
                <p className='Craft'><b>Aircraft:</b> {leg.Craft}</p>
              </div>
            </div>

            <div>
              <p className='CityName'>
                {leg.Origin?.Airport?.CityName} ({leg.Origin?.Airport?.AirportCode}) ({leg.Origin?.Airport?.AirportName})
              </p>
              <p className='DepTime'>
                {new Date(leg.Origin?.DepTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })}
              </p>
              <p className='Depdate'>
                {new Date(leg.Origin?.DepTime).toLocaleDateString('en-GB')}
              </p>
              <p className='Terminal'>Terminal {leg.Origin?.Airport?.Terminal}</p>
            </div>

            <div>
              <p className='Duration'>
                {`${String(Math.floor(leg.Duration / 60)).padStart(2,'0')}h ${String(leg.Duration % 60).padStart(2,'0')}m`}
              </p>
              <p className='StopOver'>{leg.StopOver === false ? 'Non Stop' : 'Stop'}</p>
            </div>

            <div>
              <p className='CityName'>
                {leg.Destination?.Airport?.CityName} ({leg.Destination?.Airport?.AirportCode}) ({leg.Destination?.Airport?.AirportName})
              </p>
              <p className='DepTime'>
                {new Date(leg.Destination?.ArrTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })}
              </p>
              <p className='Depdate'>
                {new Date(leg.Destination?.ArrTime).toLocaleDateString('en-GB')}
              </p>
              <p className='Terminal'>Terminal {leg.Destination?.Airport?.Terminal}</p>
            </div>
          </div>

          {/* 🔹 Layover using GroundTime */}
          {idx < segmentsFlat.length - 1 &&
           segmentsFlat[idx + 1]?.GroundTime > 0 && (
            <div className="layover-line">
              <span className="StopOver">
                ───────────── Layover:{" "}
                {Math.floor(segmentsFlat[idx + 1]?.GroundTime / 60)}h{" "}
                {segmentsFlat[idx + 1]?.GroundTime % 60}m ─────────────
              </span>
            </div>
          )}
        </React.Fragment>
      ))}

    {/* Show More / Show Less button */}
    {segmentsFlat.length > 6 && (
      <button
        type="button"
        className="btn-show-more mt-2"
        onClick={() => setShowAllSegments(!showAllSegments)}
      >
        {showAllSegments ? "Show Less" : `Show ${segmentsFlat.length - 6} More`}
      </button>
    )}
  </div>
)}


            {/* Baggage */}
          {activeTab === 'baggage' && (
  <div>
    <table className="baggage-table w-full border-collapse">
      <thead>
        <tr className="bg-gray-100">
          <th className="p-2 border">Airline</th>
           <th className="p-2 border">Sector</th>
          <th className="p-2 border">Check-in Baggage</th>
          <th className="p-2 border">Cabin Baggage</th>
        </tr>
      </thead>
      <tbody>
        {segmentsFlat.map((leg, idx) => (
          <tr key={idx} className="border-b">
            <td className='p-2 border flex items-center gap-2'>
              <img
                src={`/airlinesimages/${leg.Airline?.AirlineCode}.gif`}
                alt={`${leg.Airline?.AirlineName} Logo`}
                className="w-6 h-6"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = '/airlinesimages/default.gif';
                }}
              /> 
              {leg.Airline?.AirlineName || 'N/A'}
            </td>
            <td className='p-2 border'>{leg.Origin.Airport?.AirportCode || 'N/A'} - {leg.Destination.Airport?.AirportCode || 'N/A'}</td>
            <td className='p-2 border'>{leg.Baggage || 'N/A'}</td>
            <td className='p-2 border'>{leg.CabinBaggage || 'N/A'}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)}


            {/* Cancellation */}
           {activeTab === 'cancellation' && (
  <div>
    <h4>Cancellation / Reissue Rules</h4>
    {Array.isArray(flight?.MiniFareRules) && flight.MiniFareRules.length > 0 ? (
     

      

<div className="fare-table">
  {flight.MiniFareRules.flat().map((rule, index) => {
    // Convert 'From' to number and add 1; if it's missing or 0, it becomes 1
    const journeyFrom = (Number(rule?.From) || 0) + 1;

    return (
      <p key={index}>
        {`${rule?.JourneyPoints || '-'}- ${journeyFrom} to ${rule?.To || '-'}: ${rule?.Unit || '-'} ${rule?.Type || '-'} — ${rule?.Details || '-'}`}
      </p>
    );
  })}
</div>




    ) : (
      <p>No cancellation or reissue rules available.</p>
    )}
  </div>
)}


            {/* Fare */}
            {activeTab === 'fare' && (
              <div>
                <h4>Fare Summary</h4>
                {flight?.Fare ? (
                  <table className="fare-table">
                    <thead>
                      <tr>
                        <th>Passenger Type</th>
                        <th>Base Fare</th>
                        <th>Tax</th>
                        <th>Other Charges</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Adult</td>
                        <td>₹{flight.Fare.BaseFare?.toLocaleString('en-IN') || 0}</td>
                        <td>₹{flight.Fare.Tax?.toLocaleString('en-IN') || 0}</td>
                        <td>₹{flight.Fare.OtherCharges?.toLocaleString('en-IN') || 0}</td>
                        <td>
  ₹
  {Math.round(
    (flight.Fare.BaseFare || 0) +
    (flight.Fare.Tax || 0) +
    (flight.Fare.OtherCharges || 0)
  ).toLocaleString('en-IN')}
</td>

                      </tr>
                    </tbody>
                  </table>
                ) : (
                  <p>No fare breakdown available.</p>
                )}
                <div className="fare-total" style={{ marginTop: '1rem' }}>
                 <strong>
  Total Fare:
</strong>{' '}
₹
{meta.price ? Math.round(meta.price).toLocaleString('en-IN') : 0}
                </div>
              </div>
            )}
          </div>
        </div>
          </div>
      </div>
      )}

      {/* Fare Modal */}
      {showFareModal && selectedFareDetails && (
        <div className="fare-modal-overlay" onClick={() => setShowFareModal(false)}>
          <div className="fare-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowFareModal(false)}>×</button>
            {/* Flight summary */}
            <div className="flight-summary-bar">
              <div className="logo-section">
                <img
                  src={`/airlinesimages/${firstSegment.Airline?.AirlineCode}.gif`}
                  alt={`${firstSegment.Airline?.AirlineName} Logo`}
                  className="airline-logo"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = '/airlinesimages/default.gif';
                  }}
                />
                <div className="airline-text">
                  <strong>{firstSegment.Airline?.AirlineName}</strong>
                  <span className="route">
                    {firstSegment.Origin?.Airport?.CityName} → {lastSegment.Destination?.Airport?.CityName}
                  </span>
                  <span className="timing">
                    {new Date(firstSegment.Origin?.DepTime).toLocaleDateString('en-GB', {
                      weekday: 'short',
                      day: '2-digit',
                      month: 'short',
                      year: '2-digit'
                    })}{' '}
                    | Departure at {new Date(firstSegment.Origin?.DepTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })}{' '}
                    | Arrival at {new Date(lastSegment.Destination?.ArrTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })}
                  </span>
                </div>
              </div>
            </div>
            {/* Fare Cards */}
           <div className="fare-cards">
  {(selectedFareDetails?.FareOptions || [selectedFareDetails]).map((fare, idx) => {
    // Flatten all segments for this fare
    const segmentsFlat = fare?.Segments?.flat() || [];
    return (
      <div className="fare-card" key={idx}>
        <div className="fare-price">
          ₹{fare?.Fare?.PublishedFare?.toLocaleString('en-IN') || "N/A"}
          <span className="per-adult">Per Adult</span>
        </div>

        <div className="fare-type">
          { fare?.FareClassification?.Type || "Regular"}
        </div>

        <div className="fare-section">
          <strong>Baggage</strong>
          {segmentsFlat.map((seg, i) => (
            <p key={`bag-${i}`}>
              {seg.Origin?.Airport?.CityName} → {seg.Destination?.Airport?.CityName}: 
              {seg?.CabinBaggage || "N/A"} Cabin / {seg?.Baggage || "N/A"} Check-in
            </p>
          ))}
        </div>

        <div className="fare-section">
          <strong>Seats & Meals</strong>
          <p><b>Seat Charge:</b> {fare?.Fare?.TotalSeatCharges || "N/A"}</p>
          <p><b>Meal Charge:</b> {fare?.Fare?.TotalMealCharges || "N/A"}</p>
        </div>

<div className="fare-table">
  <strong>Cancellation or Reissue</strong>
        {Array.isArray(flight?.MiniFareRules) && flight.MiniFareRules.length > 0 ? (
          flight.MiniFareRules.flat().map((rule, index) => {
            const journeyFrom = (Number(rule?.From) || 0) + 1;
            return (
              <p key={index}>
                {`${rule?.JourneyPoints || '-'}- ${journeyFrom} to ${rule?.To || '-'}: ${rule?.Unit || '-'} ${rule?.Type || '-'} — ${rule?.Details || '-'}`}
              </p>
            );
          })
        ) : (
          <p>No cancellation or reissue rules available.</p>
        )}
      </div>


     <button
  className="btn btn-primary"
  style={{ marginTop: "1rem" }}
  onClick={() => {
    // For multicity, navigate directly to Booking with all flight details
    navigate("/book-flight", {
      state: {
        selectedOnward: flight,  // full multicity flight object
        selectedReturn: null,    // no return flight for multicity
        tripType: "multicity",   // explicitly mark as multicity
        ResultIndex: flight?.ResultIndex || "",
        TraceId: flight?.TraceId || "",
      },
    });
  }}
>
  Book Now
</button>


      </div>
    );
  })}
</div>

          </div>
        </div>
      )}
    </div>
    
  );
};

export default MultiCityFlights;
